import { render } from "./OpeningAnimation.vue?vue&type=template&id=6da819a3&scoped=true"
import script from "./OpeningAnimation.vue?vue&type=script&lang=js"
export * from "./OpeningAnimation.vue?vue&type=script&lang=js"

import "./OpeningAnimation.vue?vue&type=style&index=0&id=6da819a3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da819a3"]])

export default __exports__